module.exports = __webpack_public_path__ + "img/45.1409995a.jpg";